import * as React from 'react';
import { getAuctioneerDirectoryUrl, getSellerUrl } from '@/utils/urls';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import BreadcrumbList from '@/components/Breadcrumb/BreadcrumbList';
import { useIntl } from 'react-intl';

type Props = {
    sellerId: number;
    sellerName: string;
};

const RatingsPageBreadcrumbs = ({ sellerId, sellerName }: Props) => {
    const { formatMessage } = useIntl();

    const crumbs = [
        <Breadcrumb key="online_auctions" label={formatMessage({ id: 'online_auctions' })} target="/" type="link" />,
        <Breadcrumb
            key="auction_house_directory"
            label={formatMessage({ id: 'auction_house_directory' })}
            target={getAuctioneerDirectoryUrl()}
            type="link"
        />,
    ];

    if (sellerName) {
        crumbs.push(
            <Breadcrumb key="name" label={sellerName} target={getSellerUrl(sellerId, sellerName)} type="link" />
        );
        crumbs.push(<Breadcrumb key="reviews" label={formatMessage({ id: 'review.all_reviews' })} last type="label" />);
    }

    return <BreadcrumbList breadcrumbs={crumbs} secondaryNavigation={null} />;
};

export default React.memo<Props>(RatingsPageBreadcrumbs);
